/**
 * Contains/loads the jQuery plugins used only by the editor application.
 */
define((require) => {
    "use strict";

    const $          = require("jquery");
    const {debounce} = require("underscore");

    /**
     * Third party jquery extensions.
     */
    require("jquery.scrollintoview");
    require("jquery-contextmenu");
    require("jquery-expanding-textarea");
    require("jquery-tinyscrollbar");
    require("jquery-resize");
    require("select2");

    /**
     * Addding destroyed event to support handling callbacks
     * when an element is removed from the DOM.
     */
    if (typeof $.event.special.destroyed === "undefined") {
        $.event.special.destroyed = {
            remove(o) {
                if (o.handler) {
                    o.handler();
                }
            }
        };
    }

    /**
     * Scroll it into view, when a collapsible element is shown.
     */
    $(document).on("shown.bs.collapse", (e) => $(e.target).scrollintoview());

    /**
     * Select the inputs elements in the first click and in the second click allow the cursor to be in the right character.
     */
    let lastSelectedElement = null;
    $(document).on("mouseup", "input", (event) => {
        const type = event.target.type;

        // check if the element selected has changed
        if (event.target !== lastSelectedElement && type !== "range") {
            // Select the element
            event.target.select();
            // Save the last element
            lastSelectedElement = event.target;
            // The prevent default is important to assure the focus on the click action.
            // Otherwise, some times it will not select everything.
            event.preventDefault();
        }
    });

    /**
     * Enables adding functionality to the draghover event.
     *
     * @param  {Function} dragenterCallback Callback to be invoked when the element triggers
     *                                      the <tt>dragenter</tt> event.
     *
     * @param  {Function} dragleaveCallback Callback to be invoked on <tt>dragover</tt>.
     * @return {jQuery} The jQuery object, by convention, to make it chainable.
     */
    $.fn.draghover = function(dragenterCallback, dragleaveCallback) {
        return this.each(function() {
            const $this = $(this);
            let isEntered = false;

            $this.on("dragenter", () => {
                if (!isEntered) {
                    isEntered = true;
                    dragenterCallback();
                }
            });

            $this.on("dragover", debounce(() => {
                isEntered = false;
                dragleaveCallback();
            }, 100));
        });
    };
});



// WEBPACK FOOTER //
// ./src/editor/util/JqueryEditorPlugins.js